import { Box } from '@mui/material';
import './Loader.css';

const Loader = () => {
  return (
    <Box component="div" className="loader">
      <Box component="div" />
      <Box component="div" />
      <Box component="div" />
    </Box>
  );
};

export default Loader;
